<script setup lang="ts">
import { type EventCreateModel } from '@/types/models/EventCreateModel'
import { AutocompleteField } from '@rfc/rfc-components-library'
import * as momentTz from 'moment-timezone'

type Props = {
    data?: string
}
defineProps<Props>()

defineEmits<{
    (e: 'update', value: Partial<EventCreateModel>): void
}>()

const timezones = momentTz.tz.names().map(value => ({ value, label: value }))
</script>

<template>
    <AutocompleteField
        :label="$t('event.model.tz')"
        :modelValue="data"
        @select="$emit('update', { tz: $event?.value as string })"
        :clearable="false"
        :options="timezones"
        required
        :no-filter="false" />
</template>
